export default {
  0: '未开始',
  1: '进行中',
  2: '已暂停',
  3: '已取消',
  4: '已完成',
};
